import { ACPConsentData, BestInterestData } from './types';

export const getBestInterestData = (values: any): BestInterestData | null => {
  if (values.bestInterestOption === 'withNextOfKin') {
    return {
      nextOfKinPresent: true,
      personPresent: {
        name: values.personPresentName,
        phone: values.personPresentPhone,
      },
      professionalPresent: {
        name: values.professionalPresentName,
        phone: values.professionalPresentPhone,
      },
      secondProfessionalPresent: {
        name: values.secondProfessionalPresentName,
        phone: values.secondProfessionalPresentPhone,
      },
    };
  }
  if (values.bestInterestOption === 'withoutNextOfKin') {
    return {
      nextOfKinPresent: false,
      professionalPresent: {
        name: values.withoutNOKProfessionalPresentName,
        phone: values.withoutNOKProfessionalPresentPhone,
      },
      secondProfessionalPresent: {
        name: values.withoutNOKSecondProfessionalPresentName,
        phone: values.withoutNOKSecondProfessionalPresentPhone,
      },
    };
  }
  return null;
};

export const acpYesOptions = [
  {
    value: 'medicalRecordsSharedWithNextOfKin',
    label:
      'Yes. It can be added to my medical records and shared with my Next of Kin',
  },
  {
    value: 'medicalRecordsOnly',
    label: 'Yes. It can be added to my medical records only',
  },
  {
    value: 'sharedWithNextOfKinOnly',
    label: 'Yes. It can be shared with my Next of Kin only',
  },
  {
    value: 'sharedWithinOrganizationOnly',
    label: 'Yes. It can be shared within your organisation only',
  },
];

export const acpNoOptions = [
  {
    value: 'noNotWillingToDiscuss',
    label: 'No. Not willing to discuss',
  },
  {
    value: 'noNotAbleToDiscuss',
    label: 'No. Not able to discuss',
  },
];
